module.exports = "<div class=\"piece\" (click)=\"toggle()\" [innerHTML]=\"cleanImgTag\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pieces/pieces.component.html
// module id = ./src/app/pieces/pieces.component.html
// module chunks = 1